module.exports = __webpack_public_path__ + "img/CCC5C9_3B2B2B_67585B_7F7375-256px.c5026d65.png";